import type { AxiosError } from 'axios';
import { HeadersParams, tryRefreshAndRetry } from './api.domain';
import { callLogoutSSO, isTokenInvalid } from '../redux/auth/auth.functions';

export const handleUnauthorized = async (error: AxiosError) => {
  const headers = error.config.headers as HeadersParams;
  const isInvalidToken = isTokenInvalid(error);

  if (isInvalidToken) {
    callLogoutSSO();
    throw error;
  }

  return tryRefreshAndRetry({
    callbackError: () => Promise.reject(error),
    config: error.config,
    originalError: error,
    headers
  });
};
